import React from 'react';

const PreloadLink = ({ to, waiting, history, children, className, title }) => {
  const onClickHandler = async e => {
    e.preventDefault();
    await waiting();
    history.push(to);
  };
  return (
    <a href={to} onClick={onClickHandler} title={title} className={className}>
      {children}
    </a>
  );
};

export default PreloadLink;
